import React from "react";

function Header (props) {
    const {className, children} = props
    return (
        <header className={`${className}`}>{children}</header>
    )
}

export default Header